import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { HasQuestionsGuard } from './guards/has-questions.guard';
import { IsCitizenGuard } from './guards/is-citizen.guard';
import { HasAnswersGuard, DidNotVisitFormGuard, DidNotVisitVideoidentificationGuard, GTMService } from '@app/core';
import { ProvinceInV2Guard } from './guards/province-in-v2.guard';
import { QuestionnaireComponent } from './components/questionnaire.component';

const routes: Routes = [
	{
		path: '',
		canActivateChild: [IsCitizenGuard, ProvinceInV2Guard],
		children: [
			{
				path: '',
				component: QuestionnaireComponent,
				data: {
					module: 'questionnaire',
				},
			},
		],
	},
	{
		path: 'step/:id',
		loadChildren: () => import('./pages/step/step.module').then(module => module.QuestionnaireStepModule),
		canLoad: [IsCitizenGuard, HasQuestionsGuard],
		canActivate: [IsCitizenGuard, HasQuestionsGuard],
	},
	{
		path: 'result',
		loadChildren: () => import('./pages/result/result.module').then(module => module.ResultModule),
		data: { title: [GTMService.TENANT, GTMService.QUESTIONARY, 'Resultado del Cuestionario'].join(GTMService.SPLITTER) },
		canLoad: [IsCitizenGuard, HasQuestionsGuard],
		canActivate: [IsCitizenGuard, HasQuestionsGuard],
	},
	{
		path: 'identification',
		loadChildren: () => import('./pages/identification/identification.module').then(module => module.IdentificationModule),
		data: { title: [(GTMService.TENANT, GTMService.IDENTIFICATION, 'Identificación del solicitante')].join(GTMService.SPLITTER) },
		canLoad: [IsCitizenGuard, HasAnswersGuard, DidNotVisitFormGuard, DidNotVisitVideoidentificationGuard],
		canActivate: [DidNotVisitFormGuard, HasAnswersGuard, DidNotVisitVideoidentificationGuard],
	},
	{
		path: 'identification-select',
		loadChildren: () => import('./pages/identification-select/identification-select.module').then(module => module.IdentificationSelectModule),
		data: { title: [(GTMService.TENANT, GTMService.IDENTIFICATION, 'Identificación del presentador')].join(GTMService.SPLITTER) },
		canLoad: [IsCitizenGuard, HasAnswersGuard, DidNotVisitFormGuard, DidNotVisitVideoidentificationGuard],
		canActivate: [DidNotVisitFormGuard, HasAnswersGuard, DidNotVisitVideoidentificationGuard],
	},
	{
		path: 'videoidentification',
		loadChildren: () => import('./pages/videoidentification/videoidentification.module').then(module => module.VideoidentificationModule),
		data: { title: [(GTMService.TENANT, GTMService.IDENTIFICATION, 'VideoIdentificación')].join(GTMService.SPLITTER) },
		canLoad: [IsCitizenGuard, HasAnswersGuard, DidNotVisitFormGuard],
		canActivate: [DidNotVisitFormGuard, HasAnswersGuard],
	},
	{
		path: 'photo/:id',
		loadChildren: () => import('./pages/photo/photo.module').then(module => module.PhotoModule),
	},
	{
		path: '**',
		redirectTo: '404',
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class QuestionnaireRoutingModule {}
